import { connect } from 'react-redux';

import { selectContentCounts, selectContentCountsUpToDate } from '~selectors/ContentCountsSelector';
import { CompositeSessionInfoSelectors } from '~selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { contentCountsUpToDate } from '~src/app/actions/spaces/ContentCountsActions';
import { addContentFavorite, removeContentFavorite } from '~src/app/actions/spaces/FavoritesActions';
import { populateContentBreadcrumbs } from '~src/app/content/breadcrumbs/BreadcrumbHelpers';
import { PublishedConnectionTableSubspaceName } from '~src/app/state/SpaceInfo';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '~src/catalog/selectors/CatalogSelectors';

import { enterPublishedConnectionTableSubspace } from '../actions/EnterPublishedConnectionTableSubspaceAction';
import { publishedConnectionTableCountsRequest } from '../actions/PublishedConnectionTableCountsRequestAction';
import {
  PublishedConnectionTableSpace,
  PublishedConnectionTableSpaceDispatchProps,
  PublishedConnectionTableSpaceOwnProps,
  PublishedConnectionTableSpaceStateProps,
} from './PublishedConnectionTableSpace';

const mapStateToProps: MapStateToProps<PublishedConnectionTableSpaceStateProps> = (state) => ({
  contentCountsPublishedConnectionTable: selectContentCounts<'publishedConnectionTable'>(state, 'publishedConnectionTable'),
  urls: siteUrlsSelector(state),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<PublishedConnectionTableSpaceDispatchProps, PublishedConnectionTableSpaceOwnProps> = (dispatch, ownProps) => ({
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.publishedConnectionTableDetailInfo));
  },
  enterSpace: (requestContent: boolean) => {
    dispatch(enterPublishedConnectionTableSubspace(
      ownProps.publishedConnectionTableDetailInfo,
      ownProps.subplaceName as PublishedConnectionTableSubspaceName,
      requestContent
    ));
  },
  fetchUpdatedContentCounts: () => {
    dispatch(publishedConnectionTableCountsRequest('publishedConnectionTable'));
  },
  markContentCountsUpToDate: () => {
    dispatch(contentCountsUpToDate());
  },
  populateContentBreadcrumbs,
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.publishedConnectionTableDetailInfo));
  },
});

export const ConnectedPublishedConnectionTableSpace = connect(mapStateToProps, mapDispatchToProps)(PublishedConnectionTableSpace);
